import React from "react";
const Home = React.lazy(() => import('./Home'));

export const driveConfig = [
    {
        path: '/apps/Drive',
        element:<Home/>
    }
];